import React from 'react';
import PropTypes from 'prop-types';

const ErrorMsgField = props => {
  const { type } = props;
  let msg = '';

  switch (type) {
    case 'required':
    case 'typeError':
      msg = props.msg ? props.msg : 'Campo obrigatório';
      break;
    case 'integer':
      msg = props.msg ? props.msg : 'Somente números inteiros';
      break;
    case 'ipV4':
      msg = props.msg ? props.msg : 'Endereço ip inválido';
      break;
    case 'min':
      msg = props.msg ? props.msg : 'Abaixo do mínino permitido';
      break;
    case 'max':
      msg = props.msg ? props.msg : 'Acima do máximo permitido';
      break;
    case 'hour':
      msg = props.msg ? props.msg : 'Horário inválido';
      break;
    case 'endHour':
      msg = props.msg ? props.msg : 'Horário final inválido';
      break;
    case 'date':
      msg = props.msg ? props.msg : 'Data inválida';
      break;
    case 'day':
      msg = props.msg ? props.msg : 'Dia inválido';
      break;
    case 'month':
      msg = props.msg ? props.msg : 'Mês inválido';
      break;
    case 'repeat':
      msg = props.msg ? props.msg : 'Campo com valor repetido';
      break;
    case 'email':
      msg = props.msg ? props.msg : 'E-mail inválido';
      break;
    case 'confirmPassword':
      msg = props.msg ? props.msg : 'Senhas não conferem';
      break;
    case 'start':
      msg = props.msg ? props.msg : 'Inicio deve ser menor que o final';
      break;
    case 'end':
      msg = props.msg ? props.msg : 'Final deve ser maior que o inicio';
      break;
    case 'some':
      msg = props.msg ? props.msg : 'Nenhum item selecionado';
      break;
    case 'currency':
      msg = props.msg ? props.msg : 'Formato de moeda obrigatório 0,00';
      break;
    case 'fileFormat':
      msg = props.msg ? props.msg : 'Formato inválido';
      break;
    case 'cpf':
      msg = props.msg ? props.msg : 'CPF inválido';
      break;
    case 'cnpj':
      msg = props.msg ? props.msg : 'CNPJ inválido';
      break;
    case 'phone':
      msg = props.msg ? props.msg : 'Telefone inválido';
      break;
    case 'zipCode':
      msg = props.msg ? props.msg : 'CEP inválido';
      break;
    case 'rg':
      msg = props.msg ? props.msg : 'RG inválido';
      break;
    case 'url':
      msg = props.msg ? props.msg : 'URL inválida';
      break;
    case 'ncm':
      msg = props.msg ? props.msg : 'NCM inválido';
      break;
    default:
      msg = props.msg ? props.msg : 'Custom message';
      break;
  }
  return (
    <small className="form-text text-white error-msg m-0 pl-1 bg-danger rounded-bottom">
      {msg}
    </small>
  );
};

ErrorMsgField.propTypes = {
  type: PropTypes.string,
  msg: PropTypes.string
};

export default ErrorMsgField;
